import tenantRoutes from './tenants.route';

export default [...tenantRoutes];
